import React from 'react';
import { Grid } from 'semantic-ui-react';
// import {Redirect} from 'react-router-dom';
// import {graphql} from 'react-apollo';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../utils/queries'

//components
import Signin from './login/signin';

const styles ={
  grid: {
    height: '100%',
    width: '800px',
    margin: '0 auto',
  },
  box:{
    background: 'linear-gradient(#2a5298, #141E30)', border: '1px solid #2a5298',
    // border: '1px solid #e6e6e6',
    textAlign: 'center',
    marginBottom: '1em',
    marginTop: '4em',
    padding: '1em',
  },
  label:{
    color: '#FFE000',
    textAlign: 'left',
  },
  confirmar:{
    background: 'linear-gradient(#2c3e50, #bdc3c7, #bdc3c7 10%, #bdc3c7 10%, #bdc3c7 10%, #2c3e50)',
    border: '0px',
    color: '#135058',
    fontWeight: 'bold',
  },
  input:{
    background: 'linear-gradient(white, #999966 )',
    border: '0px',
    color: '#89253e',
  },
}

class Login extends React.Component{
  state = {
    argsUsuario: {},
    errorUsuario: []
  }

  handleLogin = async (ev, args, errors)=>{
// const response = await this.props.login({
// variables: {
//     claveDeAcceso: "wilson",
//     email: "wilson@hotmail.com",
//     _id: "5af6d775ab98252fd8a7bb82",
//     descrPerfil: "Administrador",
//     nombreUsuario: "WIlson Martinez"
// }
// });
// console.log(errors)


// const api = "https://pokeapi.co/api/v2/pokemon/1/"
// fetch(api)
// .then(response => response.json())
// .then(data => {
//   console.log(data)
// })
// .catch(err => console.log(err))


    let errores = errors
    if(!args.email||!args.claveDeAcceso) {
      const argsUsuario = this.state.argsUsuario
      const errors = [];
      if(!args.email){
        argsUsuario['email'] = "";
        errors.push({path: 'email', message: "Debe escribir el correo electrónico"});
      }
      if(!args.claveDeAcceso){
        argsUsuario['claveDeAcceso'] = "";
        errors.push({path: 'Clave de acceso', message: "Debe escribir la clave de acceso"});
      }
      this.setState({argsUsuario});
      this.setState({errorUsuario: errors})
    }else{
      let bdConn = ""
      if(errores.length>0){
        if(errores[0].path==="varias" && errores[0].message==="varias"){
          if(!args.bdConn){
            // Varias bases de datos y or defecto esta seleccionada la primera
            args.bdConn = errores[1].path
          }
        }else{
          args.bdConn = bdConn
        }
      }else{
        args.bdConn = bdConn
      }
      const response = await this.props.login({
        variables: args
      });
      const {errors, success, token, ok, dpto} = response.data.login
      // console.log(success)
      if(!success){
        this.setState({errorUsuario: errors})
      }else{
        // console.log("11")
        sessionStorage.setItem('token', token)
        // console.log("22")
        sessionStorage.setItem('userLogin', args.email)
// console.log("33", ok, dpto)
        let codigoCiudadUA = ok, nombreCiudadUA="Todas..."
        let codigoDptoUA = dpto, descrDptoUA="Todos..."
        await this.props.allDirmayor.refetch()
        // console.log("antes", this.props.allDirmayor.allDirmayor)
        const listaCiu = this.props.allDirmayor.allDirmayor
        // console.log("despues")
        listaCiu.forEach((elemento, _id) => {
          if(elemento.ciudades.length>0){
            if(elemento.codigoDpto===codigoDptoUA){
              descrDptoUA = elemento.descrDpto
            }
            elemento.ciudades.forEach((elemento1, i) => {
              if(elemento1.codigoCiudad===codigoCiudadUA){
                nombreCiudadUA = elemento1.nombreCiudad
              }
            })
          }
          // console.log("132", elemento.ciudades.length, descrDptoUA, nombreCiudadUA)
        })
        // console.log("133", descrDptoUA, nombreCiudadUA)
        sessionStorage.setItem('Ciudad', nombreCiudadUA)
        sessionStorage.setItem('Dpto', descrDptoUA)
        // console.log("55")
// console.log(nombreCiudadUA, descrDptoUA)
        let argsEncr = {valor: args.email, comparar: "no"}
        let response = await this.props.encriptar({
          variables: argsEncr
        });
        const {encriptado} = response.data.encriptar;
        // console.log("66")
        sessionStorage.setItem('token1', encriptado)
// console.log("77")
        argsEncr = {valor: nombreCiudadUA, comparar: "no"}
        response = await this.props.encriptar({
          variables: argsEncr
        });
        if(argsEncr){
          const {encriptado} = response.data.encriptar;
          // console.log("88")
          sessionStorage.setItem('token2', encriptado)
          // console.log("99")
        }
// console.log(this.props.history)
        this.props.history.push("/Home")
      }
    }
  }

  handleChange = (ev)=>{
    // console.log(ev.target.name, ev.target.value)
    const argsUsuario = this.state.argsUsuario
    if(ev.target.name==="bdConn"){
      let miLista = document.getElementById("bdConn");
      argsUsuario[ev.target.name] = miLista.options[miLista.selectedIndex].value
    }else{
      argsUsuario[ev.target.name] = ev.target.value
      this.setState({argsUsuario});
    }
      // console.log(this.state.argsUsuario)
  }
  
  render(){
//         console.log(sessionStorage.getItem('userLogin'))
// console.log(sessionStorage.getItem('token'))
    const {argsUsuario, errorUsuario} = this.state;
    // console.log("login")
    // sessionStorage.removeItem('token');
    // sessionStorage.removeItem('userLogin')
    return (
      <div className="ui grid container">
        <Grid verticalAlign='middle' columns = {2} centered style={styles.grid}>
          <Grid.Row>
            {/* <Grid.Column>
              <Image src="images/login.png" alt="Login" fluid/>
            </Grid.Column> */}
            <Grid.Column>
              <Signin styles={styles} handleSubmit={this.handleLogin} handleChange={this.handleChange} args={argsUsuario} errors={errorUsuario}/>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}

// export default graphql(queries.mutation.login)(Login)
// // export default graphql(queries.mutation.createUsuario)(Login)


export default compose(
  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),

  graphql(queries.mutation.login, {name:'login'}),
  graphql(queries.mutation.encriptar, {name:'encriptar'}),
)(Login)
